module.exports = __webpack_public_path__ + "static/media/MFSL_F1.8a76ba31.txt";